/**
 * Tokens de design do Dashboard, alinhados às variáveis do Figma
 * (-Web- Dashboard Loja). Centralizados aqui para evitar hex espalhado e
 * duplicado pelos componentes. Os nomes seguem os tokens do design.
 */
export const colors = {
  // text
  textPrimary: 'rgba(26, 26, 26, 0.87)', // text/primary  (#1a1a1ade)
  textSecondary: 'rgba(26, 26, 26, 0.6)', // text/secondary (#1a1a1a99)
  textOnDark: '#ffffff',
  // superfícies
  paper: '#ffffff', // components/paper-elevation-0
  pageBackground: '#f1f1f1', // components/paper-elevation-2
  divider: 'rgba(0, 0, 0, 0.12)', // common/divider (#0000001f)
  // semânticas
  success: '#65af84',
  warning: '#ffdd79',
  danger: '#d50030',
  infoDark: '#2031ad',
  picking: '#4DD0FF',
  returning: '#AF0D0F',
  tables: {
    red: '#ba001c',
    blue: '#2031ad',
    yellow: '#fabf1e',
  },
  bars: {
    green: '#12CD0B',
    cyan: '#4DD0FF',
    yellow: '#FABF1E',
    red: '#AF0D0F',
    magenta: '#FA1ECA'
  },
};

// elevation/1 do Figma
export const cardShadow =
  '0 1px 3px 0 rgba(0,0,0,0.03), 0 1px 1px 0 rgba(0,0,0,0.06), 0 2px 1px -1px rgba(0,0,0,0.08)';

export const cardRadius = 8;

export const typography = {
  // Titles/h3 — números grandes dos indicadores
  metricValue: { fontSize: 36, fontWeight: 500, letterSpacing: 1 },
  // Titles/h6 — títulos de seção
  sectionTitle: { fontSize: 20, fontWeight: 700, letterSpacing: 2 },
  // Body/Body 1 — descrições
  body: { fontSize: 16, lineHeight: 1.4, letterSpacing: 0.15 },
  // Overline/Overline — "META 90%"
  overline: { fontSize: 12, fontWeight: 700, letterSpacing: 1.5 },
};
